import React from 'react';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { waffleCategories, package as ContentPropType } from 'lib/CustomPropTypes';
import BTE from 'lib/BTE';
import Breakpoints from 'lib/Breakpoints';
import HeaderDisclaimer from 'components/HeaderDisclaimer';
import CollectionLead from 'components/packages/CollectionLead';

import WaffleFilter from './WaffleFilter';
import LoadingText from './LoadingPlaceholders/LoadingText';

class WaffleHeader extends React.Component {
  static propTypes = {
    activeFilters: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)),
    cardCount: PropTypes.number,
    categories: waffleCategories,
    categoryToDisplay: PropTypes.objectOf(PropTypes.string),
    clearFilter: PropTypes.func,
    content: ContentPropType.isRequired,
    description: PropTypes.string,
    disableVerticalScroll: PropTypes.func,
    enableVerticalScroll: PropTypes.func,
    filterOnChange: PropTypes.func,
    filterValues: PropTypes.objectOf(PropTypes.objectOf(PropTypes.bool)),
    isFilterActive: PropTypes.bool,
    loading: PropTypes.bool,
    shortDescription: PropTypes.string,
    showDisclaimer: PropTypes.bool,
  };

  static contextTypes = {
    vertical: PropTypes.string,
  };

  static defaultProps = {
    activeFilters: [],
    cardCount: 0,
    categories: {},
    categoryToDisplay: {},
    clearFilter: () => () => {},
    description: null,
    disableVerticalScroll: () => {},
    enableVerticalScroll: () => {},
    filterOnChange: () => () => {},
    filterValues: {},
    isFilterActive: false,
    loading: false,
    shortDescription: null,
    showDisclaimer: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      filterOverlayOpen: false,
    };
  }

  componentDidMount() {
    BTE.monitorResize();
  }

  componentWillUnmount() {
    BTE.remove('resize', this.handleResize, 'debounce');
  }

  handleResize = () => {
    if (!Breakpoints.isSorM()) {
      this.closeFilterOverlay();
    }
  }

  openFilterOverlay = () => {
    const { disableVerticalScroll } = this.props;
    disableVerticalScroll();
    BTE.on('resize', this.handleResize, 'debounce');
    this.setState({
      filterOverlayOpen: true,
    });
  }

  switchFilterOverlayUI = () => {
    if (typeof document === 'undefined') return;
    const elementsToFindFlex = ['#hfs-header'];
    const elementsToFindBlock = ['.breaking-marquee'];
    const { filterOverlayOpen } = this.state;

    elementsToFindFlex.forEach((item) => {
      const element = document.querySelector(item);
      if (element) element.style.display = filterOverlayOpen ? 'none' : 'flex';
    });

    elementsToFindBlock.forEach((item) => {
      const element = document.querySelector(item);
      if (element) element.style.display = filterOverlayOpen ? 'none' : 'block';
    });
  }

  closeFilterOverlay = () => {
    const { enableVerticalScroll } = this.props;
    enableVerticalScroll();
    BTE.remove('resize', this.handleResize, 'debounce');
    this.setState({
      filterOverlayOpen: false,
    });
  }

  tagList = () => {
    const { activeFilters, clearFilter, filterOnChange } = this.props;
    return (
      <>
        {
          activeFilters.map(({ key, category, displayName }, index) => {
            let toolkit = ['publico-hed', 'pa0', 'lh-title', 'plum', 'white-l', 'mr4-l', 'f4', 'f5-l'];
            if (index === activeFilters.length - 1) {
              toolkit = [...toolkit, 'mr0'];
            } else {
              toolkit = [...toolkit, 'mr3'];
            }
            return (
              <button
                type="button"
                className={classNames(
                  'waffle-header__tag-list-btn',
                  toolkit,
                )}
                onClick={() => filterOnChange(category)(key, false)}
                key={key}
              >
                <span
                  className={classNames('waffle-header__icon--delete f2 f3-l waffle-header__icon icon-close mr1 icon')}
                />
                {displayName}
              </button>
            );
          })
        }
        <button
          type="button"
          onClick={clearFilter}
          className={classNames('waffle-header__clear-all-btn dn di-l bg-transparent white pt0 pl0 pr0 publico-hed')}
        >
          {i18next.t('Clear all')}
        </button>
        <span className="ml2 mr2 ml3-l mr3-l mh4-l">|</span>
      </>
    );
  }

  renderDek = () => {
    const {
      shortDescription,
      description,
      showDisclaimer,
    } = this.props;
    return (
      <div className="df flex-column-reverse flex-column-m items-center">
        <p className={classNames('waffle-header__description f4 lh-copy white mb0 mt2 dn-m')}>{shortDescription}</p>
        <p className={classNames('waffle-header__description f4 lh-copy white mb0 mt2 dn db-m')}>{description}</p>
        { showDisclaimer && <HeaderDisclaimer /> }
      </div>
    );
  }

  mobileFilters = () => (
    <div className="waffle-header__layout-grid-item waffle-header__mobile-filter">
      <button
        type="button"
        className="waffle-header__filter--open__overlay-btn ph6 f5 f6-m publico-hed bg-transparent"
        onClick={this.openFilterOverlay}
      >
        Filter
        {' '}
        <span className="waffle-header__icon--angle-down f7 waffle-header__icon icon icon-angle-down" />
      </button>
    </div>
  );

  filters = () => {
    const { filterOverlayOpen } = this.state;
    const {
      clearFilter,
      categories,
      filterValues,
      filterOnChange,
      categoryToDisplay,
    } = this.props;
    const sharedBtnClasses = classNames('pv4 ph7 ph9-m flex-grow-1 flex-grow-0-m waffle-header__overlay-btn--mobile');

    return (
      <div
        className={classNames(
          'waffle-header__filters',
          'dn df-l justify-start justify-center-l mt8-l flex-column flex-row-l',
          'fixed relative-l bg-alabaster bg-transparent-l waffle-header__layout-grid-item',
          {
            'df z-max': filterOverlayOpen,
            'waffle-header__filter--open': filterOverlayOpen,
            'waffle-header__filter-overlay--open': filterOverlayOpen,
          },
        )}
      >
        <div className={classNames('waffle-header__overlay-button-wrapper z-1 sticky relative-l df dn-l founders-cond f4 justify-center bg-white pl5 pr5 pv4 mb7')}>
          <button
            type="button"
            className={classNames(sharedBtnClasses, 'mr5 mr8-m plum bg-transparent waffle-header__overlay-btn--mobile--clear-all')}
            onClick={clearFilter}
          >
            {i18next.t('CLEAR ALL')}
          </button>
          <button
            type="button"
            className={classNames(sharedBtnClasses, 'white bg-vermillion')}
            onClick={this.closeFilterOverlay}
          >
            {i18next.t('DONE')}
          </button>
        </div>
        {
          Object.entries(categories).map(([category, values]) => (
            <WaffleFilter
              key={category}
              categoryName={category}
              categoryValues={values}
              value={filterValues[category] || {}}
              onChange={filterOnChange(category)}
              categoryToDisplay={categoryToDisplay}
            />
          ))
        }
      </div>
    );
  };

  render() {
    const {
      categories,
      cardCount,
      isFilterActive,
      loading,
      content,
    } = this.props;

    this.switchFilterOverlayUI();

    const filters = Object.keys(categories);
    const hasFilters = !!filters.length;
    const filtersHaveParams = filters.some((filter) => !!categories[filter].length);

    const results = !loading && cardCount ? (
      <span className="publico-hed fs-italic f3 f4-l">
        {`${cardCount} ${i18next.t('Result')}${cardCount !== 1 ? 's' : ''}`}
      </span>
    ) : (
      <LoadingText />
    );

    return (
      <div className="waffle-header">
        <CollectionLead
          pkgClassName="pkg collectionLead waffle-header__collection-lead"
          content={content}
          dekRenderer={this.renderDek}
          postContentRenderer={() => (
            (filtersHaveParams && hasFilters)
              ? (
                <>
                  {this.filters()}
                  <div className="dn db-l mt4 mt5-m mt7-l tc plum white-l publico-text fw2 f5 waffle-header__layout-grid-item">
                    { isFilterActive && this.tagList() }
                    <span className={classNames({ 'waffle-header__loading': loading }, 'dn dib-l')}>
                      { results }
                    </span>
                  </div>
                </>
              )
              : null
          )}
        />
        { (filtersHaveParams && hasFilters)
          && (
          <div className="waffle-header__filters__cta">
            { this.mobileFilters() }
            <div className="waffle-header__filters__cta-taglist">
              { isFilterActive && this.tagList() }
              { results }
            </div>
          </div>
          )}
      </div>
    );
  }
}

export default WaffleHeader;
